import PropTypes from 'prop-types';

import Inclusion from './Inclusion';

const Offer = {
  id: PropTypes.string,
  name: PropTypes.string,
  description: PropTypes.string,
  baseIncludedOccupants: PropTypes.number,
  extraOccupantCount: PropTypes.number,
  cancellationPolicy: PropTypes.shape({
    isNonRefundable: PropTypes.bool,
    description: PropTypes.string,
  }),
  inclusions: PropTypes.arrayOf(PropTypes.shape(Inclusion)),
};

export default Offer;
